// extracted by mini-css-extract-plugin
export default {"container":"printable_container__Ao2Nr","section":"printable_section__fofEB","landscape":"printable_landscape__eUVuQ","portrait":"printable_portrait__PcR7N"};